var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#4B4B7C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00002 1C3.34317 1 2.00002 2.34315 2.00002 4V12C2.00002 13.6569 3.34317 15 5.00002 15H11.764C12.9003 15 13.9391 14.358 14.4472 13.3416L14.8945 12.4472C15.1414 11.9532 14.9412 11.3526 14.4472 11.1056C13.9533 10.8586 13.3526 11.0588 13.1056 11.5528L12.6584 12.4472C12.489 12.786 12.1427 13 11.764 13H5.00002C4.44774 13 4.00002 12.5523 4.00002 12V4C4.00002 3.44772 4.44774 3 5.00002 3H11.764C12.1427 3 12.489 3.214 12.6584 3.55279L13.1056 4.44721C13.3526 4.94119 13.9533 5.14142 14.4472 4.89443C14.9412 4.64744 15.1414 4.04676 14.8945 3.55279L14.4472 2.65836C13.9391 1.64201 12.9003 1 11.764 1H5.00002ZM9.79292 4.79289C9.40239 5.18342 9.40239 5.81658 9.79292 6.20711L10.5858 7L6.00002 7C5.44774 7 5.00002 7.44771 5.00002 8C5.00002 8.55228 5.44774 9 6.00002 9L10.5858 9L9.79292 9.79289C9.40239 10.1834 9.40239 10.8166 9.79292 11.2071C10.1834 11.5976 10.8166 11.5976 11.2071 11.2071L13.7071 8.70711C14.0977 8.31658 14.0977 7.68342 13.7071 7.29289L11.2071 4.79289C10.8166 4.40237 10.1834 4.40237 9.79292 4.79289Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLogout);
export default __webpack_public_path__ + "static/media/icn_logout.22ad5166.svg";
export { ForwardRef as ReactComponent };